// in mb
export const IMAGE_SIZE_UPLOAD_LIMIT = 70;
